<template>
  <div v-frag>
    <b-row>
      <b-colxx xxs="12">
        <div
          class="d-flex justify-content-between align-items-md-center align-items-start flex-md-row flex-column mb-2"
        >
          <piaf-breadcrumb :heading="$t('menu.list')" />

          <router-link to="/admin/options/create" class="btn btn-primary top-right-button">
            {{ $t('buttons.addNew') }}
          </router-link>
        </div>

        <div class="separator mb-5" />
      </b-colxx>
    </b-row>

    <template v-if="isLoading">
      <div class="loading"></div>
    </template>

    <template v-else>
      <data-list-item :options="options" @update="fetchOptions" />
    </template>
  </div>
</template>

<script>
import DataListItem from '@/components/Pages/Options/DataList.vue'

export default {
  components: {
    'data-list-item': DataListItem
  },
  computed: {
    options() {
      return this.$store.getters['options/options']
    },
    isLoading() {
      return this.$store.getters['options/isLoading']
    }
  },
  mounted() {
    this.fetchOptions()
  },
  methods: {
    fetchOptions() {
      this.$store.dispatch('options/fetchOptions')
    }
  }
}
</script>
